/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum PartType {
  Pain = 'Pain',
  Asymmetry = 'Asymmetry',
  Range = 'Range',
  Tissue = 'Tissue'
}
